import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractComponent} from "@components";
import {Competitor, CompetitorsCategories} from "@model";

@Component({
  selector: 'app-league-results-tab',
  templateUrl: './league-results-tab.component.html',
  styleUrl: './league-results-tab.component.scss'
})
export class LeagueResultsTabComponent extends AbstractComponent {
  @Input() competitors: Competitor[] = [];
  @Input() gender: number | undefined = undefined;
  @Output() getFileFromServer: EventEmitter<string> = new EventEmitter<string>();

  competitorCategories: CompetitorsCategories | undefined;
  category: string | undefined = undefined;
  name: string = "";

  onGetFileFromServer(type:string) {
    this.getFileFromServer.next(type);
  }

}
